import { CountryUrl, Locale } from '@/enums';
import { getRoute } from '@/helpers/RouteHelper';
import { useQueryParam } from '@/hooks/useQuery';
import { useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';
import { useSessionStorage } from "react-use";
import styled from 'styled-components';

export default function LanguageSwitcher() {
  const [language] = useQueryParam('lang');
  const [locale, setLocale] = useSessionStorage<Locale>("language");
  const { i18n } = useTranslation();

  const languages: {
    [property in CountryUrl]: {
      [lang: string]: {
        value: Locale,
        next: Locale,
      };
    }
  } = {
    [CountryUrl.Malaysia]: {
      en: {
        value: Locale.EN_MY,
        next: Locale.MS_MY,
      },
      my: {
        value: Locale.MS_MY,
        next: Locale.EN_MY,
      },
    },
    [CountryUrl.Philippines]: {
      en: {
        value: Locale.EN_PH,
        next: Locale.EN_PH,
      },
    }
  }

  const { country } = getRoute(location.pathname);
  const defaultCountryLang = languages.my;
  const countryLang = languages[country] ?? languages.my;
  const lngs = Object.entries(countryLang);

  useEffect(() => {
    if (language || countryLang !== defaultCountryLang) {
      handleLocaleChange(
        countryLang[language!]?.value ?? countryLang.en.value
      );
    }
  }, [language]);

  const handleLocaleChange = (locale: Locale) => {
    i18n.changeLanguage(locale);
    setLocale(locale);
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {locale === Locale.EN_MY ? `Switch to Bahasa Malaysia` : `Switch to English`}
    </Tooltip>
  );

  return lngs.length ? (
    <Wrapper>
      <OverlayTrigger
        placement="left"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip}
      >
        <>
          {lngs.map(([lng, { value, next }]) => (
            <i
              key={value}
              className="bi bi-globe"
              hidden={value !== i18n.language}
              onClick={() => handleLocaleChange(next)}
            >
              <Small>{lng.toUpperCase()}</Small>
            </i>
          ))}
        </>
      </OverlayTrigger>
    </Wrapper>
  ) : null;
}

const Wrapper = styled.div`
  margin-left: 2rem;
  margin-right: 1rem;
  color: #4a5568;
  font-size: 16px;
  cursor: pointer;
  display: inline;

  @media (max-width: 767px) {
    display: block;
    margin-bottom: 1rem; /* Add margin for separation on small screens */
  }
`;

const Small = styled.small`
  font-size: 14px;
`;
